import { Component, OnInit } from '@angular/core';
import { CommonService } from './core/services/common/common.service';
import { NavigationEnd, Router } from '@angular/router';
import { LoaderService } from './core/services/loader/loader.service';
import { UrlConfig } from './core/config/url.config';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'NewHire';
  constructor(
    public _commonService: CommonService,
    public _loaderService: LoaderService,
    private router: Router
  ) {
    this.saveGroupInfo();
    this._commonService.setBrokerMobileConfig();
    if (environment.enableCSP) {
      this.loadContentSecurityPolicyScript();
    }
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      // Scroll to top if accessing a page
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  // allow keys these to be saved to localStorage, ignore any others (for security purposes)
  acceptableKeys = [
    // for broker mobile app
    'bma',
    // for Quote Lite
    'redirectUrl',
    // keys below are for WB Quote
    'group_id',
    'broker_id',
    'broker_state',
    'salesRepName',
    'broker_name',
    'broker_LicenseNumber',
    'broker_Phone',
    'salesRepEmail',
  ];

  saveGroupInfo() {
    var qs =
      window.location.hash != ''
        ? window.location.hash
        : window.location.search;

    // ignore the '#code' part
    if (qs.startsWith('#')) {
      qs = qs.replace(/^#.+\?/, '');
    }

    let tokens = qs.split(/[?&]/);

    if (qs == '' || tokens.length == 0) {
      localStorage.setItem('IsDirectUser', 'Yes');
      localStorage.setItem('FromApp', 'direct');
      return;
    }

    localStorage.setItem('IsDirectUser', 'No');

    let keyProcessed = 0;
    tokens.forEach((v, i) => {
      let kv = v.split('=');
      if (kv.length < 2) return;

      let key = kv[0];
      let keyup = key.toUpperCase();
      let value = kv[1];

      let match = false;
      this.acceptableKeys.forEach((v, i) => {
        if (v.toUpperCase() == keyup) match = true;
      });
      if (!match) return;

      keyProcessed++;
      // --------------------------------
      // process keys from BMA
      // --------------------------------
      if (keyup == 'BMA') {
        if (value === '1') localStorage.setItem('isBma', value);
        localStorage.setItem('FromApp', 'bma');
        this.setUserAcceptedDisclaimerAgreement();
        return;
      }

      // --------------------------------
      // process keys from QuoteLite
      // --------------------------------
      if (keyup == 'REDIRECTURL') {
        const regex = new RegExp(
          '(http(s)?://((.+.)?(www\\.)?wordandbrown.com|(.+.)?localhost:d+))'
        );
        const redirectURL = value + '/';
        localStorage.setItem(
          key,
          regex.test(redirectURL) ? redirectURL : UrlConfig.quoteLiteUrl
        );
        localStorage.setItem('FromApp', 'quotelite');
        this.setUserAcceptedDisclaimerAgreement();
        return;
      }

      // --------------------------------
      // process keys from WBQuote
      // --------------------------------

      localStorage.setItem(key, value);
      localStorage.setItem('IsFromWBQuote', 'Yes');
      localStorage.setItem('FromApp', 'wbquote');
      this.setUserAcceptedDisclaimerAgreement();
    });

    if (keyProcessed == 0) {
      localStorage.setItem('IsDirectUser', 'Yes');
      localStorage.setItem('FromApp', 'direct');
    }
  }
  private setUserAcceptedDisclaimerAgreement() {
    // user has already agreed on the disclaimer (via the transferring website)
    // set this so the unsupported browser can be triggered.
    localStorage.setItem('isWebApp', 'true');
    this._commonService.isTermsAccepted = true;
  }

  public loadContentSecurityPolicyScript(): void {
    const cspScriptPolicy =
      'object-src ' +
      `${environment.cspObjectSrc}` +
      'connect-src ' +
      `${environment.cspConnectSrc}` +
      'font-src ' +
      `${environment.cspFontSrc}` +
      'frame-src ' +
      `${environment.cspFrameSrc}` +
      'img-src ' +
      `${environment.cspImgSrc}` +
      'media-src ' +
      `${environment.cspMediaSrc}` +
      'worker-src ' +
      `${environment.cspWorkerSrc}` +
      'script-src ' +
      `${environment.cspScriptSrc}` +
      'style-src ' +
      `${environment.cspStyleSrc}` +
      'require-trusted-types-for ' +
      `${environment.cspRequireTrustedTypesFor}`;
    // Inject a <meta> tag
    console.log(cspScriptPolicy);
    var cspMetaTag = document.createElement('meta');
    cspMetaTag.setAttribute('http-equiv', 'Content-Security-Policy');
    cspMetaTag.setAttribute('content', cspScriptPolicy);
    document.getElementsByTagName('head')[0].appendChild(cspMetaTag);
  }
}
